import { useState , useEffect } from "react"
import Header from "./Header"
import Form from "./Form"
import TodosList from "./TodosList"
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';






export default function App() {

 const keepState = JSON.parse(localStorage.getItem("todes")) || [];
   const [input, setInput] = useState("")
   const [todes, setTodes] = useState(keepState)
   const [editTodo, setEditTodo] = useState(null)
   

   useEffect(() =>{
    localStorage.setItem("todes", JSON.stringify(todes))
   },[todes])

  return (
    
   <div className="flex justify-center  items-center min-h-[100vh] bg-[#474f97]" >
    <section className="w-[23rem] drop-shadow-2xl  lg:w-[25rem]  h-[35rem]  bg-[#121858] rounded-md  ">
  
      <div>
        <Header/>
      </div>
      <div>
        <Form
        input ={input}
        setInput={setInput}
        todes={todes}
        setTodes={setTodes}
        editTodo={editTodo}
        setEditTodo={setEditTodo}
          />
      </div>
      <div>
       <TodosList todes={todes} setTodes={setTodes} setEditTodo={setEditTodo}/>
      </div>
    
    </section>
 
   
   </div>
  )
}









